import { IconButton } from "@mui/material";
import { Flex } from "~/components/Flex";
import { Search } from "~/components/search/search";
import { useSearch } from "~/components/search/useSearch";
import { SplitDownArrowIcon } from "~/icons";

export interface FilterBarProps {
  searchId: string; // id for search component
  placeholder: string;
  onlyShowFilters?: boolean; // if true, only show the filters and not the search
  showFilters?: boolean;
  search: ReturnType<typeof useSearch>;
  mb?: number; // margin bottom if desired => TODO remove mb on all filter bars by default
}

export const FilterBar = ({
  searchId,
  placeholder,
  search,
  showFilters = false,
  mb = 3,
  onlyShowFilters = false,
}: FilterBarProps) => {
  const { searchFilters, handleFilterQuery, onTagDelete } = search;

  return (
    <Flex sx={{ mb: mb, gap: 5 }}>
      <Search
        id={searchId}
        onDelete={onTagDelete}
        {...{
          searchFilters,
          handleFilterQuery,
          placeholder,
          onlyShowFilters,
        }}
      />

      {showFilters && (
        <IconButton sx={{ alignSelf: "center" }}>
          <SplitDownArrowIcon />
        </IconButton>
      )}
    </Flex>
  );
};
